import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    users: {
      edit: {
        title: '対象の利用者/利用%{name}の検索',
        fields: {
          name: '氏名',
          address: '住所',
          place: '物件名'
        },
        buttons: {
          search: '検索'
        }
      },
      show: {
        title: '解約予定日の入力',
        fields: {
          stop: '解約予定日',
          phone: '携帯電話番号',
          family: {
            name: '緊急連絡先氏名',
            nameKana: '緊急連絡先氏名カナ(全角)',
            sms: '緊急連絡先SMS送信先電話番号',
            phone: '緊急連絡先電話番号',
            postalCode: '緊急連絡先郵便番号'
          },
          schedules: '不在予定'
        },
        buttons: {
          submit: '設定'
        },
        list: {
          title: '対象の利用者/利用%{name}を選択してください'
        },
        record: {
          title: '対象の利用者/利用%{name}'
        },
        notifications: {
          notFound: '該当する利用者/利用%{name}が見つかりません。'
        }
      },
      fields: {
        name: '氏名/%{name}名',
        code: '%{name}コード',
        address: '住所',
        phone: '電話番号',
        start: '利用開始日',
        stop: '解約予定日',
        end: '解約日',
        status: 'ご利用状況',
        product: 'ご担当管理会社',
        contractor: {
          name: '電気契約名義',
          address: '電気契約名義住所'
        },
        classification: '受給区分（受電／供給）',
        spin: '受電/供給地点特定番号'
      }
    },
    dashboard: {
      title: 'テラシテSサービス管理ページ',
      menu: {
        admin: {
          accounts: 'アカウント管理',
          mappings: '%{name}管理'
        },
        spot: '%{name}単位表示',
        compare: '%{name}間比較表示',
        spotData: '%{name}データ出力',
        summary: '分析データ出力'
      },
      notification: {
        cannotUse: 'ご利用できません'
      },
      dialogs: {
        selectMonth: {
          title: '抽出期間の選択',
          buttons: {
            exec: 'ダウンロード',
            cancel: '閉じる'
          }
        },
        selectDate: {
          title: '日付の選択',
          buttons: {
            exec: '実行',
            cancel: '閉じる'
          }
        }
      }
    },
    download: {
      dialog: {
        content:
          '利用者/利用%{name}一覧を取得するURLをメールでお送りします。\nなお、URLの有効期限は1日となっています。\n\n有効期限を過ぎた場合はこちらのページから再度、手続きを行ってください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'ダウンロード'
        }
      }
    },
    upload: {
      dialog: {
        content:
          '取得した利用者/利用%{name}一覧のファイルに変更内容を入力したファイルのアップロードを行ってください。\n\nなお、解約予定日、電話番号、緊急連絡先の情報以外の項目を変更されても反映されませんのでご注意ください。',
        buttons: {
          cancel: 'キャンセル',
          confirm: 'アップロード'
        }
      },
      notification: {
        uploading: 'アップロード中...',
        'cannot upload': 'アップロードできません。'
      }
    },
    partnerSelect: {
      dialog: {
        buttons: {
          prev: '前へ',
          next: '次へ',
          cancel: 'キャンセル',
          confirm: '設定'
        },
        title: '事業者の選択'
      }
    },
    cognito: {
      download: {
        dialog: {
          content:
            '登録済みのアカウントの一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        },
        notification: {
          downloading: 'ダウンロード中...',
          downloadError: 'ダウンロードできません。'
        }
      },
      upload: {
        dialog: {
          content:
            '必ず取得したフォーマットのファイルのアップロードを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード',
            format: 'フォーマットのダウンロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          uploadError:
            'ファイル形式が正しくないか数量が多いため処理できません。',
          result: '新規登録: %{addAccounts}件, 更新: %{updateAccounts}件',
          deleting: '削除中...',
          deleteError: '削除できません。',
          deleteResult: '削除完了'
        },
        delete: {
          dialog: {
            content: '%{deleteAccounts}件の削除を実行します。',
            buttons: {
              cancel: 'キャンセル',
              confirm: '実行'
            }
          }
        }
      },
      execute: {
        confirm: 'アカウントの削除を実行するには、ボタンを押してください。',
        buttons: {
          execute: '実行'
        },
        dialog: {
          title: 'アカウントの削除の実行',
          content: 'アカウントの削除を実行します。',
          cancel: 'キャンセル',
          confirm: '実行'
        }
      }
    },
    accounts: {
      fields: {
        name: '氏名',
        email: 'メールアドレス',
        group: '役割',
        managedBy: '管理者',
        area: '%{area}',
        office: '%{office}',
        status: '初回ログイン'
      },
      buttons: {
        create: '新規登録',
        upload: '一括登録・削除・更新',
        download: '登録情報の取得'
      },
      dialogs: {
        create: {
          title: 'アカウント新規登録'
        },
        edit: {
          title: 'アカウント編集'
        },
        mutate: {
          buttons: {
            cancel: 'キャンセル',
            done: '登録'
          }
        },
        selectManager: {
          title: '利用者の管理者の選択'
        },
        confirm: {
          title: '',
          content: 'アカウントの削除を実行しますか'
        }
      },
      groups: {
        admin: 'システム管理者',
        highManager: '上位管理者',
        manager: '管理者',
        user: '利用者'
      }
    },
    mappings: {
      fields: {
        name: '%{name}名',
        spin: '地点番号',
        code: '%{code}',
        managedBy: '担当者',
        'managedBy.name': '氏名',
        'managedBy.email': 'メールアドレス',
        'managedBy.helperText': 'クリックして選択',
        'managedBy.helperTextEdit': 'クリックして変更',
        ownedBy: 'オーナー',
        'ownedBy.name': '氏名',
        'ownedBy.email': 'メールアドレス',
        'ownedBy.helperText': 'クリックして選択',
        'ownedBy.helperTextEdit': 'クリックして変更',
        floorArea: '面積（㎡）',
        group: 'グルーピング'
      },
      dialogs: {
        edit: {
          title: '%{name}登録編集'
        },
        mutate: {
          buttons: {
            cancel: 'キャンセル',
            done: '登録',
            delete: '削除'
          },
          confirm: {
            title: '',
            content: '%{name}の削除を実行しますか'
          }
        },
        selectAccount: {
          title: '担当者の選択',
          buttons: {
            cancel: 'キャンセル',
            clear: '削除',
            done: '設定'
          }
        },
        selectOwnerAccount: {
          title: 'オーナーの選択'
        }
      },
      download: {
        dialog: {
          content:
            '登録済みの%{name}の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        },
        notification: {
          downloading: 'ダウンロード中...',
          downloadError: 'ダウンロードできません。',
          noAccounts: '担当者に設定できるアカウントが登録されていません。'
        }
      },
      upload: {
        dialog: {
          content:
            '必ず取得した登録済みの%{name}の一覧のファイルを編集した\nファイルのアップロードを行ってください。\n\n',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          uploadError:
            'ファイル形式が正しくないか数量が多いため処理できません。',
          result: '更新: %{updates}件'
        }
      }
    },
    spots: {
      tabs: {
        daily: '日単位',
        monthly: '月単位',
        monthlyCalendar: '月単位\nカレンダー表示',
        yearly: '年単位',
        demand: 'デマンド'
      },
      demandTabs: {
        yearly: '年間推移',
        monthly: '月間推移',
        daily: '日毎推移',
        trend: '発生傾向',
        trendHint:
          '選択月の各日の最大DMが 発生した回数を時間帯毎に表示しています。\nこれによって、DMが発生 しやすい時間帯を把握す ることができます。'
      },
      daily: {
        compareTo: {
          lastWeek: '前週同曜日',
          lastYearWithMonthlyAverage: '前年同月平均',
          lastYearWithYearlyAverage: '前年年間平均'
        },
        comment: {
          buttons: {
            close: '閉じる',
            send: '送信'
          },
          label: 'コメント（任意）',
          placeholder:
            '例：表示されているアクションを実行して使用量が下がった、表示されているアクションを実施したが使 用量が下がらなかった…etc'
        }
      },
      monthly: {
        compareTo: {
          lastYear: '前年同月',
          lastMonth: '前月',
          lastYearWithMonthlyAverage: '前年同月平均'
        }
      },
      yearly: {
        compareTo: {
          lastYear: '前年度'
        }
      },
      fields: {
        date: '対象日'
      },
      compareTo: '比較データ',
      target: '比較対象',
      others: '他の%{name}',
      tempature: '気温推移',
      maxTempature: '最高気温',
      minTempature: '最低気温',
      buttons: {
        download: 'ダウンロード'
      }
    },
    spotData: {
      fields: {
        base: 'ファイル名',
        threshold: '前日比較差の閾値'
      },
      buttons: {
        pdf: 'PDFダウンロード',
        data: 'データダウンロード'
      },
      caution:
        '＜注意＞\n既にデフォルト値として以下の内容が入力されております。\n※デフォルト値から変更してダウンロードされる場合は、ダウンロードに一定の時間を要します。\n【時間単位/日】\n比較元：前週（前週の日～土曜日）　比較対象：前週比　比較差の閾値：1.5\n※比較差の閾値に1.5を入力すると比較対象から150%以上の電気使用量になった時間帯を色付けいたします。\n【日単位/月】\n比較元：出力する日が属する月　比較対象：前年比　目標値の設定値：97.7％\n【月単位/年】\n出力する日の属する年度　比較対象：前年度'
    },
    missingsDialog: {
      title: 'データ不足%{name}リスト',
      content: '以下の%{name}は、データ保持開始日以降のデータが出力可能です',
      list: {
        name: '%{name}',
        from: 'データ保持開始日'
      },
      buttons: {
        close: '閉じる',
        exec: 'ダウンロードを実行'
      }
    },
    spotData2: {
      selected: '選択した%{name}',
      fields: {
        base: 'ファイル名',
        daily: {
          title: '時間単位/日',
          date: '比較元',
          compareTo: '比較対象',
          threshold: '比較差の閾値'
        },
        monthly: {
          title: '日単位/月',
          date: '比較元',
          compareTo: '比較対象',
          threshold: '目標値の設定値(%)'
        },
        yearly: {
          title: '月単位/年',
          date: '比較元',
          compareTo: '比較対象',
          threshold: '比較差の閾値'
        }
      }
    },
    spotSelect: {
      dialog: {
        title: '%{name}の選択'
      },
      buttons: {
        trigger: '%{name}の選択',
        all: 'すべて選択',
        clear: '選択解除',
        close: '閉じる'
      },
      errors: {
        limit: '選択できるのは<%= limit %>%{name}までです。'
      }
    },
    spotList: {
      buttons: {
        all: 'すべて選択',
        clear: '選択解除'
      }
    },
    compare: {
      selected: '選択した%{name}',
      buttons: {
        target: '対象月',
        input: '変数データ\nインポート',
        format: '変数データ\nフォーマットダウンロード',
        close: '閉じる',
        set: '設定',
        execute: '実行',
        compare: '詳細比較'
      },
      show: {
        0: '比較元',
        1: '比較先'
      },
      fileSelect: 'インポートするファイルを選択 ',
      fields: {
        dataKey: {
          label: 'インポートするデータ名',
          helperText:
            'インポートするデータが何のデータか名称を入力ください。\n（例：売上、来客数、延床面積など）'
        },
        sourceKey: {
          label: '集計に使用する項目名',
          helperText:
            '比較用データとして設定するデータが何のデータか入力ください。\n（例：売上、来店数、延床面積など）'
        },
        targetKey: {
          label: '照合する項目名',
          helperText:
            '電力量のデータにおいて、照合に使用する各%{name}の項目の名称を選択してください'
        },
        dateKey: {
          label: '照合する月の形式',
          helperText:
            '指定されたCSVファイルにおいて、照合に使用する月の項目の表示形式を選択してください'
        },
        categories: {
          label: 'グラフの分類項目の設定',
          labels: {
            '0': '左下の凡例名',
            '1': '右下の凡例名',
            '2': '左上の凡例名',
            '3': '右上の凡例名'
          }
        }
      },
      dialogs: {
        select: {
          title: 'インポートデータの選択'
        }
      }
    },
    allData: {
      fields: {
        all: 'すべての%{name}'
      },
      buttons: {
        download: 'データダウンロード',
        clear: '対象%{name}の選択解除'
      }
    },
    announce: {
      title: '  お知らせ'
    },
    summarys: {
      fields: {
        name: '%{name}',
        daily: '時間単位/日',
        monthly: '日単位/月',
        yearly: '月単位/年',
        'daily.date': '比較元',
        'daily.compareTo': '比較対象',
        'monthly.date': '比較元',
        'monthly.compareTo': '比較対象',
        'yearly.date': '比較元',
        'yearly.compareTo': '比較対象'
      }
    },
    mergedUsers: {
      fields: {
        name: '%{name}名',
        spin: '供給/受電地点特定番号',
        kind: '契約種別',
        address: '住所'
      }
    },
    footer: {
      text: '© Chubu Electric Power Miraiz Connect, Inc. All rights reserved'
    },
    admin: {
      announces: {
        top: 'お知らせ編集管理',
        title: '事業者別',
        commonTitle: '共通',
        label: '②お知らせ内容の編集ファイルのダウンロード',
        fileSelect: 'アップロードするファイルを選択',
        download: '編集用ファイルのダウンロード',
        files: {
          label: '➀お知らせに添付するファイルのアップロード',
          fileSelect: 'アップロードするファイルを選択'
        },
        upload: '登録',
        uploadLabel: '③お知らせ内容の編集ファイルのアップロード',
        uploadFail: 'アップロードに失敗しました',
        uploadComplete: 'アップロード完了',
        downloadFail: 'ファイルの取得に失敗しました',
        preview: 'プレビュー',
        close: '閉じる'
      }
    },
    editData: {
      title: 'データ補正可能な%{name}',
      buttons: {
        upload: '補正データのアップロード',
        download: '補正データフォーマットダウンロード'
      },
      download: {
        dialog: {
          content:
            'データ補正可能な%{name}の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'ダウンロード'
          }
        },
        notification: {
          downloading: 'ダウンロード中...',
          downloadError: 'ダウンロードできません。'
        }
      },
      upload: {
        dialog: {
          content:
            '必ず取得したフォーマットのファイルを編集した\nファイルのアップロードを行ってください。',
          buttons: {
            cancel: 'キャンセル',
            confirm: 'アップロード'
          }
        },
        notification: {
          uploading: 'アップロード中...',
          done: 'アップロード完了',
          uploadError:
            'ファイル形式が正しくないか数量が多いため処理できません。',
          result: '新規登録: %{addAccounts}件, 更新: %{updateAccounts}件'
        }
      }
    },
    demandAlert: {
      title: 'リスクアラートメール管理（デマンド）',
      labels: {
        threshold: '➀リスクアラートメールの閾値',
        targets: '②リスクアラートメールの送付先（複数選択可）'
      },
      buttons: {
        register: '登録'
      },
      targets: {
        highManager: '本社担当者',
        middleManager: '%{area}担当者',
        manager: '%{office}担当者',
        areaUser: 'エリアマネージャ',
        user: '%{name}担当者',
        owner: 'パートナー事業者'
      },
      notification: {
        done: '登録完了',
        error: '登録できません'
      }
    },
    dashboard2: {
      title: 'ダッシュボード',
      tabs: {
        all: '全社',
        first: '%{area}',
        second: '%{office}',
        place: '担当\n%{name}',
        rank: '%{name}\nランキング',
        demand: 'デマンド',
        compare: '他変数\n原単位比較'
      },
      demandTabs: {
        all: '全社',
        first: '%{area}',
        second: '%{office}',
        third: '担当\n%{name}'
      },
      targetTabs: {
        weekly: '週次比較',
        monthly: '月次比較'
      },
      buttons: {
        download: 'ダウンロード'
      }
    }
  },
  scheduleInput: {
    clear: 'クリア',
    cancel: 'キャンセル',
    set: '設定'
  },
  ra: {
    ...jaMessages.ra,
    auth: {
      ...jaMessages.ra.auth,
      require_new_password: '新しいパスワードを設定してください',
      username: 'アカウント(メールアドレス)',
      password: 'パスワード',
      confirm_password: 'パスワード(確認用)',
      sign_in: 'ログイン',
      sign_in_error: 'ログインエラー',
      auth_check_error: 'メールアドレスまたはパスワードが違います',
      forgot_password: 'パスワードをお忘れ/ご変更の方はこちらから',
      exec_forgot_password: '新しいパスワードの設定',
      require_verification_code: 'メールに届いた確認コードを入力してください',
      verification_code: '確認コード',
      send_verification_code: '確認コードを送信'
    },
    validation: {
      ...jaMessages.ra.validation,
      do_not_match: 'パスワードが一致しません'
    }
  },
  menu: {
    title: 'メニュー',
    data: '電力の実績データ',
    dataItems: {
      dashboard: 'ダッシュボード',
      spot: '%{name}単位',
      allData: 'データ抽出'
    },
    admin: '管理機能',
    adminItems: {
      board: '管理画面',
      loginLog: 'ログインログデータ抽出',
      accounts: 'アカウント管理',
      spots: '%{name}管理',
      announces: 'お知らせ編集',
      data: 'データ補正',
      demand: 'リスクアラートメール管理（デマンド）',
      commentLog: '省エネアクション評価結果データ抽出'
    },
    home: 'ホーム'
  },
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  'Expected string, received null': '入力必須です',
  downloading: 'ダウンロードしています',
  'no compare data': '比較データがありません',
  'not use slash': '/は使用できません',
  'no data': '取得可能なデータがありません',
  loading: 'データ取得中',
  'no area': 'アカウントで所属する%{area}が設定されていません',
  'asigned users':
    '%{users}：%{name}担当者を複数の%{name}に割り当てることはできません。',
  'account create failed': '登録できません'
}
